module.exports = __webpack_public_path__ + "media/img/logos/2023/swiss_national_day-307a9698a8cf2520d459edb72d9acc8f.svg";